// extracted by mini-css-extract-plugin
module.exports = {"StatusDropdown":"StatusDropdown--1HpST","ToFollowUp":"ToFollowUp--39TiW","Done":"Done--dLswr"};